module.exports = __webpack_public_path__ + "img/znyyb.60b840cb.png";